import React from "react";
import PropTypes from "prop-types";
import AuthorFooter from "./AuthorFooter";
import { FaChevronUp } from "react-icons/fa";

class RecommendedArticleFooter extends React.Component {
  getRelatedPostFooterClasses = () => {
    return this.props.showRelatedPosts === true ? "shown" : "hidden";
  };

  scrollStep() {
    const scrollStepInPx = 50;
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - scrollStepInPx);
  }

  backToTop = () => {
    const delayInMs = "8.66";
    let intervalId = setInterval(this.scrollStep.bind(this), delayInMs);
    this.setState({ intervalId: intervalId });
  };

  render() {
    const { theme, next, prev } = this.props;
    return (
      <React.Fragment>
        <section className={`relatedposts ${this.getRelatedPostFooterClasses()}`}>
          {prev ? (
            <a href={prev.fields.slug} className="previouspost">
              <img
                src={prev.frontmatter.cover.childImageSharp.thumb.src}
                alt={prev.frontmatter.title}
              />
              <div className="info">
                <span>Previous Post</span>
                <span className="title">{prev.frontmatter.title}</span>
              </div>
            </a>
          ) : null}
          <span className="backtotop" onClick={this.backToTop}>
            <span className="topIcon">
              <FaChevronUp />
            </span>
          </span>
          {next ? (
            <a href={next.fields.slug} className="nextpost">
              <img
                src={next.frontmatter.cover.childImageSharp.thumb.src}
                alt={next.frontmatter.title}
              />
              <div className="info">
                <span>Next Post</span>
                <span className="title">{next.frontmatter.title}</span>
              </div>
            </a>
          ) : null}
        </section>

        {/* --- STYLES --- */}
        {/*language=SCSS*/}
        <style jsx>{`
          .relatedposts {
            overflow: hidden;
            position: relative;
            padding: 22px 25px 15px;

            .previouspost,
            .nextpost {
              float: left;
              display: block;
            }

            .nextpost {
              float: right;
              text-align: right;
            }

            img {
              display: block;
              float: left;
              width: 30px;
              height: 30px;
              border-radius: 60px;
              margin-right: 10px;
            }

            .nextpost img {
              float: right;
              margin-right: 0px;
              margin-left: 10px;
            }

            .info {
              float: left;
            }

            .nextpost img {
              float: right;
            }

            span {
              display: block;
              font-family: ${theme.font.reidweb.subheader};
              font-size: 12px;
              line-height: normal;
              color: #8f99a3;
              text-transform: uppercase;
            }

            .title {
              color: #585858;
              font-family: ${theme.font.reidweb.header};
              font-size: 15px;
              text-transform: none;
            }

            .backtotop {
              display: block;
              cursor: pointer;
              width: 28px;
              height: 28px;
              position: absolute;
              background: ${theme.colour.grey.medium};
              top: 35%;
              left: 50%;
              text-align: center;
              line-height: 25px;
              border-radius: 90px;
              @include transform(translate(-50%, -50%));
              @include transition(background 0.15s ease-in-out);

              .topIcon {
                font-size: 14px;
                color: #fff;
                padding-top: 6px;
              }

              &:hover {
                background: ${theme.colour.grey.darkest};
              }
            }

            &.hidden {
              display: none;
            }

            &.shown {
              display: block;
            }
          }
        `}</style>
      </React.Fragment>
    );
  }
}

RecommendedArticleFooter.propTypes = {
  theme: PropTypes.object.isRequired,
  showRelatedPosts: PropTypes.bool.isRequired,
  next: PropTypes.object,
  prev: PropTypes.object
};

export default RecommendedArticleFooter;
